// useSessionCheck.js
import { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

export const useSessionCheck = (logoutCallback) => {
    const [isVisibleRedirectLogin, setIsVisibleRedirectLogin] = useState(false)
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        const expiration = localStorage.getItem("sessionExpiration");
        if (expiration && Date.now() > Number(expiration)) {
        setIsVisibleRedirectLogin(true)
        // Sessão expirada
        // localStorage.removeItem("sessionExpiration");
        // logoutCallback?.();
        // history.push("/");
        }
    }, [location, history, logoutCallback]); // verifica sempre que muda de rota


    const closeModalRedirect = () => {
        localStorage.removeItem("sessionExpiration");
        setIsVisibleRedirectLogin()
        logoutCallback?.();
        history.push("/");
    }

    return{
        closeModalRedirect, isVisibleRedirectLogin
    }
};
